import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["sendButton", "countdown"]
    static values = {
        countdownTranslation: String
    }

    connect() {
        this.setupCodeValidation();
        this.countdownInterval = null;
        this.remainingSeconds = 0;
    }

    disconnect() {
        this.clearCountdown();
    }

    setupCodeValidation() {
        const codeInput = this.element.querySelector('input[name="code"]');
        if (codeInput) {
            codeInput.setAttribute('maxlength', '4');
            codeInput.setAttribute('inputmode', 'numeric');
            codeInput.setAttribute('pattern', '[0-9]{4}');
            codeInput.setAttribute('autocomplete', 'one-time-code');

            codeInput.addEventListener('input', (e) => this.validateCode(e));
        }
    }

    validateCode(event) {
        const input = event.target;
        input.value = input.value.replace(/\D/g, '');

        if (input.value.length > 4) {
            input.value = input.value.substring(0, 4);
        }
    }

    startCountdown(event) {
        const response = event?.detail?.response;

        if (!response) {
            return;
        }

        if (response.general_error) {
            const retryAfter = response.action_data?.retry_after;

            if (!retryAfter) {
                return;
            }

            this.beginCountdown(retryAfter);

            return;
        }

        this.beginCountdown(300);
    }

    beginCountdown(seconds) {
        this.clearCountdown();

        this.remainingSeconds = seconds;

        if (this.hasSendButtonTarget) {
            this.sendButtonTarget.disabled = true;
        }

        if (this.hasCountdownTarget) {
            this.countdownTarget.style.display = 'block';
            this.updateCountdownText();
        }

        this.countdownInterval = setInterval(() => {
            this.remainingSeconds--;
            this.updateCountdownText();

            if (this.remainingSeconds <= 0) {
                this.clearCountdown();
            }
        }, 1000);
    }

    updateCountdownText() {
        if (this.hasCountdownTarget) {
            this.countdownTarget.textContent = `${this.countdownTranslationValue} ${this.remainingSeconds}s`;
        }
    }

    clearCountdown() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
            this.countdownInterval = null;
        }

        if (this.hasSendButtonTarget) {
            this.sendButtonTarget.disabled = false;
        }

        if (this.hasCountdownTarget) {
            this.countdownTarget.style.display = 'none';
        }
    }
}
